export const UNCATEGORIZED_ID = 'uncategorized';
export const NO_CLIENT_SELECTION_ID = 'no-client-selection';
export const NO_CLIENT_ID = 'no-client';
export const NO_PROJECT_ID = 'no-project';
export const NO_TASK_ID = 'no-task';
export const NO_TASK_SELECTION_ID = 'no-task-selection';
export const DEFAULT_POLLING_INTERVAL = 60 * 1000;
